import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  template: `
    <div class="modal-header">
      <h4 class="modal-title" ngbAutofocus>{{ title }}</h4>
      <button type="button" class="close" aria-label="Close" (click)="logout()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>{{ body }}</p>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="logout()"
      >
        登出
      </button>
    </div>
  `
})
export class LogoutModalComponent {
  title: string;
  body: string;
  constructor(public activeModal: NgbActiveModal) {}
  logout() {
    location.href = '/';
  }
}

@Component({
  template: `
    <div class="modal-header">
      <h4 class="modal-title" ngbAutofocus>{{ title }}</h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="activeModal.close()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>{{ body }}</p>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="activeModal.close()"
      >
        確定
      </button>
    </div>
  `
})
export class FileErrorModalComponent {
  title: string;
  body: string;
  constructor(public activeModal: NgbActiveModal) {}
}
